import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/post/new',
    owner: '/',
    authority: 'articleListItemNew',
    component: Loadable({
      loader: () => import('./new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/post/:id/mod',
    owner: '/',
    authority: 'articleListItemEdit',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/post2/new',
    owner: '/',
    authority: 'articleListItemNew',
    component: Loadable({
      loader: () => import('./new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/post2/:id/mod',
    owner: '/',
    authority: 'articleListItemEdit',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  }
];